import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import 'leaflet/dist/leaflet.css'
import './index.css'
import App from './App.jsx'
import { ToastProvider } from './contexts/ToastContext'

// Initialize Sentry
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE || 'development',

    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Performance traces sample rate
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,

    // Session Replay sample rate
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

    // Filter out sensitive data
    beforeSend(event, hint) {
      // Remove passwords from form data
      if (event.request?.data) {
        const data = event.request.data;
        if (typeof data === 'object') {
          if (data.password) data.password = '[Filtered]';
          if (data.oldPassword) data.oldPassword = '[Filtered]';
          if (data.newPassword) data.newPassword = '[Filtered]';
        }
      }

      return event;
    },

    // Ignore certain errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      // Random plugins/extensions
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      // Facebook errors
      'fb_xd_fragment',
      // Network errors that are expected
      'Network request failed',
      'NetworkError',
      // ResizeObserver loop errors (not harmful)
      'ResizeObserver loop',
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });

  console.log(`Sentry initialized for ${import.meta.env.MODE} environment`);
} else {
  console.log('Sentry DSN not provided - error tracking disabled');
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
)
